module.exports = __webpack_public_path__ + "img/terms_logo.a3f6c477.png";